(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var nav = document.querySelector('.navbar-absolute');
    if(!nav) return;

    var toggles = nav.querySelectorAll('.mobile-nav-toggle');
    var panel = document.getElementById('mobileNavPanel');
    var overlay = document.getElementById('w-nav-overlay-0');
    var closeBtn = panel ? panel.querySelector('.mobile-nav-close') : null;

    function setExpanded(expanded){
      toggles.forEach(function(btn){
        btn.setAttribute('aria-expanded', expanded);
      });
      if(panel){
        panel.setAttribute('aria-hidden', expanded === 'false');
      }
    }

    function openPanel(){
      if(!panel) return;
      panel.classList.add('is-open');
      document.body.classList.add('nav-locked');
      setExpanded('true');
      overlay && overlay.classList.add('is-active');
    }

    function closePanel(){
      if(!panel) return;
      panel.classList.remove('is-open');
      document.body.classList.remove('nav-locked');
      setExpanded('false');
      overlay && overlay.classList.remove('is-active');
    }

    toggles.forEach(function(button){
      button.addEventListener('click', function(evt){
        evt.preventDefault();
        if(panel.classList.contains('is-open')){
          closePanel();
        } else {
          openPanel();
        }
      });
    });

    closeBtn && closeBtn.addEventListener('click', function(){
      closePanel();
    });

    overlay && overlay.addEventListener('click', closePanel);

    document.addEventListener('keyup', function(evt){
      if(evt.key === 'Escape'){
        closePanel();
      }
    });
  });
})();
